import api from "@/api";

const namespaced = true;

const state = {
  loadingMonitoring: {}
}

const getters = {
  loadingMonitoring: state => state.loadingMonitoring
}

const mutations = {
  SET_LOADING_MONITORING: (state, payload) => {
    state.loadingMonitoring = payload;
  }
}

const actions = {
  async fetchLoadingMonitoring({ commit }, payload) {
    try {
      const { data } = await api.getLoadingMonitoringKpi(payload)

      if (data.error) {
        commit('SET_LOADING_MONITORING', null)
        return
      }

      commit('SET_LOADING_MONITORING', data)
    } catch (error) {
      throw error;
    }
  }
}

export default { namespaced, state, getters, mutations, actions }